<script setup lang="ts">
    import { LogOut } from "lucide-vue-next";

    import Button from "@/components/tellscale/primitives/Button.vue";

    import LegalNav from "@/components/tellscale/LegalNav.vue";
    import AppControls from "@/components/tellscale/utilities/AppControls.vue";
    import PortalLogo from "@/components/tellscale/primitives/PortalLogo.vue";

    import { useI18n } from "@/composables/useI18n.ts";

    import { useAuth } from "@/stores/auth";

    const auth = useAuth();

    const { t } = useI18n();

    const logout = async () => {
        await auth.logout();
    }
</script>

<template>
    <div class="h-screen w-full flex flex-col">
        <div class="flex justify-between p-3 bg-popover shadow">
            <div class="w-2/12"/>

            <div class="flex grow justify-center items-center h-full">
                <PortalLogo :size="7" class="my-1"/>
            </div>

            <div class="flex items-end justify-end gap-3 flex-wrap-reverse w-2/12 min-w-28">
                <AppControls class="flex justify-end items-start"/>

                <Button @click="logout" v-if="auth.isAuthenticated" variant="outline" size="sm">
                    <LogOut/> {{ t('layouts.dashboardFrame.logoutButton') }}
                </Button>
            </div>
        </div>

        <div class="flex grow px-3 py-12 justify-center">
            <slot/>
        </div>

        <div class="flex justify-center p-3 bg-background shadow-2xl">
            <LegalNav/>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>